import { render, staticRenderFns } from "./ProductImagesSlider.vue?vue&type=template&id=472de0f5"
import script from "./ProductImagesSlider.vue?vue&type=script&lang=js"
export * from "./ProductImagesSlider.vue?vue&type=script&lang=js"
import style0 from "./ProductImagesSlider.vue?vue&type=style&index=0&id=472de0f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports